// Class
import { SmartTagBase } from './smartTagBase';
// Model
import { SmartTagModel } from './smartTag.model';

export class SmartTagCompromiseModel extends SmartTagModel {
	deficiencySeverity?: string;

	constructor() {
		super();
		this.deficiencySeverity = '';
	}
}

export class SmartTagCompromise extends SmartTagBase {

	/**
	 * Renderer
	 * @param data SmartTagUpdateModel
	 */
	public render(data: SmartTagCompromiseModel, version?: string): string {
		this.getData(data);

		return this.getOutputData(version || 'v1');
	}

	private getData(data: SmartTagCompromiseModel): void{
		const title = data.title || data.subCategory || '';
		const description = data.description?.trim() || '';
		const deficiencySeverity = data.deficiencySeverity || null;

		if (title !== '') {
			this.title = `<span title="${title}">Type: ${title}</span>`;
		}

		if (deficiencySeverity !== null) {
			this.addText(`<span title="Compromises livability?"> <i class=" ${deficiencySeverity ? 'fa fa-check-square' : 'fa-square far'}"></i> Compromises livability? </span>`);
		}

		if (description !== '') {
			this.addText(`<span title="${description}">Description: ${description}</span>`);
		}
	}
}
